module.exports = __webpack_public_path__ + "static/media/arrow_white.e7697102.png";